/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { formatDate } from "date-fns";
import LocationsFilterBarV2 from "components/servicePoints/filter-bar";
import Loader from "components/PageLoader";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetServicePointListPaginated } from "../../services/service-points";
import { initialDataState } from "./constants";
import BreadCrumb from "components/breadCrumb";

export default function LocationsList() {
  const [locations, setLocations] = useState([]);

  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;

  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: "",
    selectedCustomerId: "",
  });
  const {
    mutate: getServicePointsList,
    isSuccess: servicePointListAvailable,
    data: servicePointsList,
    isPending: gettingServicePointsList,
    reset: resetLocationsList,
  } = useGetServicePointListPaginated();

  useEffect(() => {
    if (servicePointListAvailable) {
      setLocations(servicePointsList.data.data);
      setTotalRecords(servicePointsList.data.totalRecords);
      resetLocationsList();
    }
  }, [servicePointListAvailable]);

  useEffect(() => {
    setCurrentPage(1);
    getServicePointsList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: formatDate(new Date(), "yyyy-MM-dd'T'00:00:00.000'Z'"),
      cashCenterId: filters.selectedCashCenterId || "",
      customerId: filters.selectedCustomerId || "",
    });
  }, [filters]);

  const viewServicePointCell = ({ dataItem }) => {
    if (canViewDetails) {
      return (
        <td>
          <Flex
            as={Link}
            to={`${Paths.locationDetails}/${dataItem.servicePointId}`}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            w="100%"
            title="View"
          >
            {dataItem.locationId}
          </Flex>
        </td>
      );
    }
    return <td> {dataItem.locationId}</td>;
  };

  const editServicePointCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editLocations}/${dataItem.servicePointId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getServicePointsList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
      customerId: filters.selectedCustomerId || "",
    });
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "ServicePoint", "Edit");
  }, [user]);
  const canViewDetails = useMemo(() => {
    return HasPermission(user, "ServicePoint", "View");
  }, [user]);

  return (
    <Flex className="main-container">
      {gettingServicePointsList ? <Loader /> : <></>}
      <Flex px="20px">
        <BreadCrumb
          links={[
            { text: "Dashboard", link: Paths.dashboard },
            { text: "Locations", isCurrentPage: true },
          ]}
        />
      </Flex>
      <Card m="20px">
        <CardBody>
          <LocationsFilterBarV2
            getList={(filter, cashCenterId, customerId) => {
              setFilters({
                searchCriteria: filter,
                selectedCashCenterId: cashCenterId,
                selectedCustomerId: customerId,
              });
            }}
          />
          <Grid
            data={process(locations || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            className="location-list-grid"
          >
            <Column
              field="locationId"
              title="Location Id"
              filterable={false}
              cell={viewServicePointCell}
              width={150}
            />
            <Column field="cashCenter" title="Cash Center" width={120} />
            <Column field="customer" title="Customer" width={120} />
            <Column field="locationName" title="Location" />
            <Column field="locationType" title="Location Type" width={150} />
            <Column field="machineType" title="Machine Type" width={140} />
            <Column field="maker" title="Maker" width={120} />
            <Column field="barcode" title="Barcode" width={120} />
            <Column field="state" title="Region" width={120} />
            <Column field="emirate" title="Emirate" width={120} />
            <Column field="city" title="City" width={120} />
            <Column field="status" title="Status" width={120} />

            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editServicePointCell}
                filterable={false}
                sortable={false}
              />
            ) : (
              <></>
            )}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
